import Glide from '@glidejs/glide'

class Carousel {
    load(){
        // TODO: carousel aus bootstrap entfernen und Klassen an Bootstrap angleichen
        const carousels =  document.querySelectorAll('.glide');
        carousels.forEach(function(element){
            let carousel = new Glide(element, {
                type: 'carousel',
                perView: 1,
                peek: {
                    before: 0,
                    after: 0
                },
                classes: {
                  direction: {
                    ltr: 'glide--ltr',
                    rtl: 'glide--rtl'
                  },
                  slider: 'glide--slider',
                  carousel: 'glide--carousel',
                  swipeable: 'glide--swipeable',
                  dragging: 'glide--dragging',
                  cloneSlide: 'glide__slide--clone',
                  activeNav: 'glide__bullet--active',
                  activeSlide: 'glide__slide--active',
                  disabledArrow: 'glide__arrow--disabled'
                }
            });

            carousel.on('mount.after', function() {
                const slides = document.querySelectorAll('.glide__slide');
                slides.forEach(function (slide) {
                    slide.classList.add('animated', 'fadeIn', 'delay-2s');
                });
            });
            carousel.mount();
        });
    }
}


export let carousel = new Carousel();